import {getRequest, postRequest, deleteRequest} from "../api";

const notificationRoute = "/iroh/notification/notifications";

export const getNotificationList = (/*query, options = {}*/) => {
  return getRequest(`${notificationRoute}`);
};

export const updateStatus = (id, data) => {
  return postRequest(
    `${notificationRoute}/${encodeURIComponent(id)}/status`,
    data
  );
};

export const deleteNotification = id => {
  return deleteRequest(`${notificationRoute}/${encodeURIComponent(id)}`, null);
};
